import React from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewArticleRelatedProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
}

const ViewArticleRelated: React.FC<ViewArticleRelatedProps> = ({ entities }) => (
  <div className="ViewArticleRelated">
    <div className="row">

      {entities.map((entity) => {
        const article = entity.toJS();
        const id = article.nid[0].value;
        const uuid = article.uuid[0].value;
        const langcode = article.langcode[0].value;
        const key = `${uuid}:${langcode}`;

        return (
          <div className="col-12 col-lg-4" key={key}>
            <Node
              entity={entity}
              viewMode="teaser"
              classes="ArticleTeaser"
            />
          </div>
        );
      })}

    </div>
  </div>
);

export default ViewArticleRelated;
